export default __webpack_public_path__ + "images/baba-compliant-logo.svg?12f195ce7a9648c9aed8068647f2c4ee";